import { render, staticRenderFns } from "./extension-list.vue?vue&type=template&id=d32cad56"
import script from "./extension-list.vue?vue&type=script&lang=js"
export * from "./extension-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports